import { useSelector } from 'react-redux';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { selectCurrentClient } from '../../../../../../CommonSelectors/CommonAreaSelector';
import { useIncomeQuery } from '../../../../../../ProfileOPL/Income/api/useIncomeQuery';
import { areBothPartiesCurrentlyReceiving } from './areBothPartiesCurrentlyReceiving';

export const useAreBothPartiesCurrentlyReceiving = () => {
  const clientId = useClientId();
  const { PartnerName } = useSelector(selectCurrentClient);
  const { data } = useIncomeQuery({ clientId: String(clientId) });

  return areBothPartiesCurrentlyReceiving({
    incomes: data?.Incomes,
    hasSpouse: PartnerName != null && PartnerName !== '',
  });
};
